module.exports = __webpack_public_path__ + "static/media/Layers.2db86239.svg";